export * from './strategy.component';
export * from './spare-parts.component';
export * from './edit/edit.component';
export * from './spare-parts-edit/edit.component';

